function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F3F7FF",
  d: "M46 82a7 7 0 110-14H7a7 7 0 110-14h40a7 7 0 100-14H22a7 7 0 110-14h40a7 7 0 110-14h57a7 7 0 010 14h64a7 7 0 010 14h22a7 7 0 010 14h-19a7 7 0 000 14h6a7 7 0 010 14H46zm163 0a7 7 0 110-14 7 7 0 010 14z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#75A4FE",
  strokeLinecap: "round",
  strokeWidth: 2.5,
  d: "M139.873 90.12c3.038-1.956 5.74-4.395 7.497-6.364m2.836-3.273a47.66 47.66 0 009.431-19.056 48.303 48.303 0 00-1.327-27.01 47.94 47.94 0 00-5.843-11.546 48.664 48.664 0 00-5.06-6.18 48.44 48.44 0 00-9.022-7.343 47.947 47.947 0 00-10.95-5.102 48.327 48.327 0 00-26.156-.926 47.613 47.613 0 00-12.256 4.868 47.933 47.933 0 00-9.605 7.198 47.811 47.811 0 00-9.027 11.963 47.76 47.76 0 00-4.72 13.37 48.348 48.348 0 00-.582 14.457A48.067 48.067 0 0078.35 83.38 48.147 48.147 0 0094.696 94.5a48.308 48.308 0 0022.85 3.412 47.783 47.783 0 0018.705-5.76"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#A4C3FE",
  strokeLinecap: "round",
  strokeWidth: 2.5,
  d: "M98.182 10.701a41.582 41.582 0 00-5.954 2.789c-2.99 1.7-5.816 3.8-8.404 6.298a42.34 42.34 0 00-2.984 3.195m-2.875 3.844a41.568 41.568 0 00-3.319 6.053"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E8F0FE",
  d: "M108 52.79l9.326.21c-1.388.736-2.157 2.076-2.305 4.022-.148 1.946.206 3.953 1.062 6.022h-6.855a11.477 11.477 0 00.992-6.022c-.213-2.093-.953-3.504-2.22-4.233z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E8F0FE",
  d: "M126.057 63c2.497 2.352 2.497-.432 4.834 9.093.53 2.16-.92 4.312-3.236 4.806a4.604 4.604 0 01-.96.101h-28.39C95.926 77 94 75.204 94 72.988c0-.301.036-.601.108-.895 2.337-9.525 2.337-6.98 4.196-9.093h27.753zm-7.22-10c2.497-1.695 11.135-9.571 8.818-9.927a6.328 6.328 0 00-.96-.073h-28.39c-2.378 0-.392 2.191-.123 2.388 5.512 4.022 5.96 6.089 7.818 7.612h12.837z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#75A4FE",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M94.108 34.305a4.37 4.37 0 01-.108-.967C94 30.942 95.927 29 98.304 29h28.391c.323 0 .645.037.96.11 2.317.533 3.766 2.86 3.236 5.195-2.337 10.299-6.653 16.53-12.946 18.695 6.293 2.165 10.609 8.396 12.946 18.695.53 2.335-.92 4.662-3.236 5.196a4.309 4.309 0 01-.96.109h-28.39C95.926 77 94 75.058 94 72.662c0-.325.036-.65.108-.967 2.337-10.299 6.653-16.53 12.946-18.695-6.293-2.165-10.609-8.396-12.946-18.695z"
}));

var SvgPaymentProcessing = function SvgPaymentProcessing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 100
  }, props), _ref);
};

export default SvgPaymentProcessing;